import React , { Fragment } from 'react'


const renderTextArea = ({ textarea, label, type, meta: { touched, error } }) => (
  <Fragment>
    <div className="form-group">
      <label>{ label }</label>
        <textarea
          { ...textarea }
          type={type}
        />
       { touched && error &&  <span> { error }</span> }
    </div>  
  </Fragment>
)

export default renderTextArea


// WEBPACK FOOTER //
// /Users/kentorry/Server/CLIENT-SERVER/CLIENT-WORK/afrodesiamedia/SERVER/afrodesiamedia/src/pages/GettingStarted/helpers/renderTextArea.js